import React from 'react';

export default () => (
  <div className="text-description">
    <p>
      <b>How it works</b>
    </p>
    <p>
      1.) Toggle ON the desired service and go through all the wizard to complete the integration.
      Syncing will begin 15 minutes thereafter using the default folder and file format structure shown below.
    </p>
    <p>
      2.)  If desired, select a custom folder and/or file format configuration using the configuration wizard below.
    </p>
    <p>
      <b>Important Facts on Integrations</b>
    </p>
    <p>
      1.) After any sync has been made, if you rename, delete or move a folder on the selected service, OR if you
      change your default configuration after a sync, we will create a new folder and continue syncing according to
      the template you set below.
    </p>
    <p>
      2.) If you change your default configurations later, you can choose to re-sync at any time by clicking the
      re-sync button.  But you will be responsible for overages that result if you sync over 250 PDFs in any given
      month.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/Integrations/connections/InstructionsPanel.jsx